/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEarningsChart} from '../api'

 export const useQueryGetEarningsChart = createReactQueryHook('getEarningsChart', getEarningsChart)
